/**
 * 合同签字区 HTML（须与后端 ContractSignatureBlockRenderer 保持一致）。
 * 模板实时预览使用；正式 PDF 由服务端渲染。
 */

/** 签字区固定高度（pt），与后端一致 */
const SIG_AREA_HEIGHT = '56pt'
const SIG_IMG_HEIGHT = '48pt'

function escapeHtml(s) {
  if (s == null) return ''
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function metaRow(label, value) {
  const v = value == null || String(value).trim() === '' ? '—' : escapeHtml(value)
  return (
    '<div style="margin:0 0 5pt;line-height:1.45;font-size:10pt;">' +
    '<span style="color:#6b7280;display:inline-block;min-width:58pt;vertical-align:top;">' +
    escapeHtml(label) +
    '</span><strong style="color:#111827;word-break:break-all;overflow-wrap:anywhere;">' +
    v +
    '</strong></div>'
  )
}

/** 固定尺寸签字区：待签 / 已签占相同高度，签字图缩放适配不撑开外框 */
function buildSignatureArea(signed, awaitingText, imageSrc) {
  const boxBase =
    'height:' +
    SIG_AREA_HEIGHT +
    ';overflow:hidden;box-sizing:border-box;line-height:0;width:100%;'
  if (signed && imageSrc) {
    return (
      '<div style="' +
      boxBase +
      'border-bottom:1.2pt solid #1f2937;">' +
      '<img src="' +
      escapeHtml(imageSrc) +
      '" alt="" style="display:block;height:' +
      SIG_IMG_HEIGHT +
      ';width:100%;max-width:100%;object-fit:contain;object-position:left bottom;margin:0;border:0;padding:0;"/>' +
      '</div>'
    )
  }
  if (signed) {
    return '<div style="' + boxBase + 'border-bottom:1.2pt solid #1f2937;"></div>'
  }
  return (
    '<div style="' +
    boxBase +
    'border-bottom:1.2pt dashed #9ca3af;display:table;">' +
    '<div style="display:table-cell;height:' +
    SIG_AREA_HEIGHT +
    ';vertical-align:middle;text-align:center;color:#9ca3af;font-size:9pt;line-height:normal;">' +
    escapeHtml(awaitingText) +
    '</div></div>'
  )
}

export function buildSignatureBlockHtml(opts) {
  const title = (opts && opts.title) || 'Signature'
  const signed = !!(opts && opts.signed)
  const awaitingText = (opts && opts.awaitingText) || 'Awaiting signature'

  const signatureCell = buildSignatureArea(
    signed,
    awaitingText,
    signed && opts && opts.imageSrc ? opts.imageSrc : null
  )

  const meta = []
  meta.push(metaRow('Name', signed && opts ? opts.signerName : null))
  meta.push(metaRow('Signed at', signed && opts ? opts.signedAt : null))

  return (
    '<table style="width:100%;table-layout:fixed;border-collapse:collapse;border:1px solid #d1d5db;margin:0;box-sizing:border-box;">' +
    '<tr><td style="padding:8pt 10pt 4pt;font-size:8.5pt;color:#6b7280;' +
    'letter-spacing:0.05em;text-transform:uppercase;word-wrap:break-word;">' +
    escapeHtml(title) +
    '</td></tr>' +
    '<tr><td style="padding:0 10pt 6pt;">' +
    signatureCell +
    '<div style="margin-top:4pt;font-size:9pt;color:#6b7280;">Signature</div>' +
    '</td></tr>' +
    '<tr><td style="padding:6pt 10pt 8pt;border-top:1px solid #e5e7eb;">' +
    meta.join('') +
    '</td></tr>' +
    '</table>'
  )
}

export function buildDraftSignatureBlockHtml(title, awaitingText) {
  return buildSignatureBlockHtml({
    title,
    signed: false,
    awaitingText: awaitingText || 'Awaiting signature'
  })
}
